import { SwarmPlotCustomLayerProps } from '@nivo/swarmplot'
import { joinDefinedStrings } from 'ComponentLibrary/src/common/strings'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { ComparisonDatum } from 'ComponentLibrary/src/molecules/ComparisonChart/types'
import { estimateLabelWidth } from 'ComponentLibrary/src/molecules/ComparisonChart/labels'
import { isEmpty } from 'lodash'

export const ComparisonChartReference = ({ nodes, xScale, innerHeight, innerWidth }: SwarmPlotCustomLayerProps<ComparisonDatum>) => {
    if (isEmpty(nodes)) {
        return null
    }

    const firstNode = nodes[0]
    const referenceValue = firstNode.data.reference

    if (referenceValue === undefined) {
        return null
    }

    const formattedReferenceValue = joinDefinedStrings([
        firstNode.data.formattedReference,
        firstNode.data.referenceUnit ?? firstNode.data.unit,
    ])
    const referenceX = xScale(referenceValue)
    const estimatedTextWidth = estimateLabelWidth(formattedReferenceValue)
    const halfEstimatedTextWidth = estimatedTextWidth / 2
    const labelCenterX = Math.min(Math.max(referenceX, halfEstimatedTextWidth), innerWidth - halfEstimatedTextWidth)
    const textCorrectionX = labelCenterX - referenceX

    return (
        <g transform={`translate(${referenceX}, 0)`}>
            <rect
                x={-halfEstimatedTextWidth + textCorrectionX}
                width={estimatedTextWidth}
                dominantBaseline={'middle'}
                height="24px"
                y={`-${tokens.SizingSpacing300}`}
                rx={tokens.SizingCornerM}
                fill={tokens.ColorBorderPositive}
            />
            <text y={-7} x={textCorrectionX} textAnchor="middle" fill={tokens.ColorTextInverse} fontSize={tokens.FontSizeXs}>
                {formattedReferenceValue}
            </text>
            <line y1={-8} y2={innerHeight + 8} stroke={tokens.ColorBorderPositive} strokeWidth={tokens.SizingBorderM} />
        </g>
    )
}
